module.exports = __webpack_public_path__ + "img/reembolso.39124f41.svg";